// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".defaultV2{background:#f5f5f5!important}.defaultV2 .v-application--wrap{margin-left:auto;margin-right:auto;max-width:720px!important}.defaultV2 .v-application--wrap .v-content__wrap{background:#fff}.defaultV2 .v-application--wrap .v-content__wrap .container{padding:0}.defaultV2 .v-dialog{width:720px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
